import { search, scrollToProducts } from "algolia-instant-search";

const { connectRefinementList } = instantsearch.connectors;

if (!customElements.get("algolia-refinement-list")) {
  class AlgoliaRefinementList extends HTMLElement {
    attribute = this.dataset.attribute;
    heading = this.dataset.heading;

    connectedCallback() {
      this.selectElements();
      this.attachListeners();

      const customRefinementList = connectRefinementList(
        this.renderRefinementList.bind(this),
      );

      search.addWidgets([
        customRefinementList({
          container: this.querySelector("#content"),
          attribute: this.attribute,
          heading: this.heading,
          operator: "and",
          limit: Infinity,
          sortBy: ["isRefined", "name:asc"],
        }),
      ]);
    }

    selectElements() {
      this.filterGroupTemplate = this.querySelector("template#filter-group");
      this.filterTemplate = this.querySelector("template#filter");
      this.content = this.querySelector("#content");
    }

    renderRefinementList(renderOptions, isFirstRender) {
      const { items, refine, widgetParams } = renderOptions;

      if (isFirstRender) {
        const filterSkeleton = document.querySelector(
          ".collection-filters_form.skeleton",
        );
        if (filterSkeleton) filterSkeleton.style.display = "none";

        const filterGroupClone =
          this.filterGroupTemplate.content.cloneNode(true);
        const details = filterGroupClone.querySelector("details");
        details.className = `filter-group filter-group--${widgetParams.attribute}`;

        const heading =
          widgetParams.heading ||
          widgetParams.attribute
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
        filterGroupClone.querySelector("#heading").textContent = heading;

        widgetParams.container.appendChild(filterGroupClone);
      }

      const filtersContainer =
        widgetParams.container.querySelector(".jsFilterWrapper");
      filtersContainer.innerHTML = "";

      items
        .sort((a, b) => a - b)
        .forEach((item) => {
          const filterClone = this.filterTemplate.content.cloneNode(true);

          const input = filterClone.querySelector("input");
          const filterId = `filter-${item.value.replace(/\s+/g, "-")}`;
          input.id = filterId;
          input.checked = item.isRefined;

          const label = filterClone.querySelector("label");
          label.setAttribute("for", filterId);

          filterClone.querySelector(".filter-label").textContent = item.label;
          filterClone.querySelector(".jsCounter").textContent = item.count;

          input.addEventListener("change", () => {
            refine(item.value);
            scrollToProducts();
          });

          filtersContainer.appendChild(filterClone);
        });

      // Update clear button on every render with current items
      const clearBtn = widgetParams.container.querySelector(
        ".jsFilterGroupClear",
      );
      const newClearBtn = clearBtn.cloneNode(true);
      clearBtn.parentNode.replaceChild(newClearBtn, clearBtn);

      newClearBtn.addEventListener("click", (e) => {
        e.preventDefault();
        items.forEach((item) => {
          if (item.isRefined) refine(item.value);
        });
        scrollToProducts();
      });
      const hasRefinements = items.some((item) => item.isRefined);
      newClearBtn.classList.toggle("none", !hasRefinements);
    }

    attachListeners() {}
  }
  customElements.define("algolia-refinement-list", AlgoliaRefinementList);
}
